var _path, _g, _path2, _path3, _path4, _rect, _rect2, _path5, _rect3, _rect4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoReferenceLight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 184,
    height: 184,
    viewBox: "0 0 184 184",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_13225_9151",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 184,
    height: 184
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 184V0H183.942V184H0Z",
    fill: "#76ABC4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_13225_9151)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M183.947 91.9423C183.947 142.784 142.731 184 91.8896 184C41.0479 184 -0.167969 142.784 -0.167969 91.9423C-0.167969 41.1007 41.0479 -0.115234 91.8896 -0.115234C142.731 -0.115234 183.947 41.1007 183.947 91.9423Z",
    fill: "url(#paint0_linear_13225_9151)"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M120.193 142.362H62.8434C60.3084 142.362 57.8772 141.355 56.0847 139.562C54.2922 137.77 53.2852 135.338 53.2852 132.803V56.3372V128.024C53.2852 130.559 54.2922 132.991 56.0847 134.783C57.8772 136.576 60.3084 137.583 62.8434 137.583H120.193C122.728 137.583 125.159 136.576 126.952 134.783C128.744 132.991 129.751 130.559 129.751 128.024V132.803C129.751 135.338 128.744 137.77 126.952 139.562C125.159 141.355 122.728 142.362 120.193 142.362Z",
    fill: "#E6E6E6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M128.751 128.025C128.751 130.294 127.85 132.471 126.245 134.076C124.64 135.681 122.463 136.583 120.193 136.583H62.8434C60.5736 136.583 58.3968 135.681 56.7918 134.076C55.1868 132.471 54.2852 130.294 54.2852 128.025V51.5583C54.2852 49.2885 55.1868 47.1117 56.7918 45.5067C58.3968 43.9017 60.5736 43 62.8434 43H120.193C122.463 43 124.64 43.9017 126.245 45.5067C127.85 47.1117 128.751 49.2885 128.751 51.5583V128.025Z",
    fill: "white",
    stroke: "#BABABA",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M103.246 42.4929V60.8943C103.246 61.5135 103.585 62.074 104.1 62.3109L104.631 62.4282C104.997 62.4284 105.348 62.2667 105.609 61.9779L111.552 55.3946L117.496 61.9779C117.757 62.2667 118.108 62.4284 118.474 62.4282L119.003 62.3109C119.254 62.1976 119.47 62.0023 119.622 61.75C119.775 61.4977 119.857 61.1998 119.859 60.8943V42.4929H103.246Z",
    fill: "#6F6FF1"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 61.7148,
    y: 93.1619,
    width: 58.1445,
    height: 2.49191,
    rx: 1.24595,
    fill: "#D6D6D6"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 64.207,
    y: 104.791,
    width: 47.3462,
    height: 1.66127,
    rx: 0.830636,
    fill: "#D6D6D6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M67.5293 77.3797C68.1864 77.3797 68.8288 77.1848 69.3752 76.8198C69.9216 76.4547 70.3475 75.9358 70.5989 75.3286C70.8504 74.7215 70.9162 74.0535 70.788 73.409C70.6598 72.7645 70.3434 72.1724 69.8787 71.7078C69.414 71.2431 68.822 70.9267 68.1775 70.7985C67.533 70.6703 66.8649 70.7361 66.2578 70.9875C65.6507 71.239 65.1318 71.6649 64.7667 72.2113C64.4016 72.7576 64.2068 73.4 64.2068 74.0572C64.2068 74.9384 64.5568 75.7835 65.1799 76.4066C65.803 77.0297 66.6481 77.3797 67.5293 77.3797ZM72.5131 85.6861C72.7334 85.6861 72.9447 85.5986 73.1005 85.4428C73.2562 85.287 73.3437 85.0757 73.3437 84.8554C73.3437 83.3133 72.7312 81.8344 71.6407 80.744C70.5503 79.6536 69.0714 79.041 67.5293 79.041C65.9872 79.041 64.5083 79.6536 63.4179 80.744C62.3274 81.8344 61.7148 83.3133 61.7148 84.8554C61.7148 85.0757 61.8024 85.287 61.9581 85.4428C62.1139 85.5986 62.3252 85.6861 62.5455 85.6861H72.5131Z",
    fill: "#D6D6D6"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 62.543,
    y: 98.9763,
    width: 20.7659,
    height: 1.66127,
    rx: 0.830636,
    fill: "#E6E6E6"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 65.0352,
    y: 109.775,
    width: 21.5965,
    height: 1.66127,
    rx: 0.830636,
    fill: "#E6E6E6"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_13225_9151",
    x1: 3.51433,
    y1: 3.75118,
    x2: 131.843,
    y2: 119.56,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#525050",
    stopOpacity: 0.06
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoReferenceLight);
export default __webpack_public_path__ + "static/media/no-reference-light.a5cb435590a559b478d8016d24ec131e.svg";
export { ForwardRef as ReactComponent };